import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit, computed, inject, signal } from '@angular/core';
import { Subject, map } from 'rxjs';
import {
  Cuenta,
  NotificacionPlaceToPay,
  RecargaPlaceToPay,
  SuscripcionPlaceToPay,
  VehiculoInterface,
} from 'src/app/core/models/global.model';

import { GuardService } from 'src/app/core/services/guards.service';
import { globalConfig } from 'src/app/core/utils/globalConfig';

export const RECARGA_AUTOMATICA_DRAFT_KEY = 'recarga_automatica_draft';
export const RECARGA_AUTOMATICA_LINK_PENDING_KEY = 'recarga_automatica_link_pending';

@Injectable({
  providedIn: 'root',
})
export class FormasPagoService implements OnInit {
  isPlaceToPayScriptCharged: boolean = false;
  activeStep: number = 0;
  formaPagoSeleccionada!: string;
  ipAddress!: string;

  guardService = inject(GuardService);

  http = inject(HttpClient);

  #stateVehiculo = signal<any>({
    vehiculos: [],
    paginacion: {},
  });

  #stateMedioPago = signal<any>({
    medioPago: [],
    loading: true,
    cuentaId: null,
  });

  public datosVehiculos = computed(() => this.#stateVehiculo());
  public stateMedioPago = computed(() => this.#stateMedioPago());
  public medioPago = computed(() =>
    this.#stateMedioPago().cuentaId === this.guardService.usuarioData().cuenta?.id
      ? this.#stateMedioPago().medioPago
      : [],
  );

  constructor() {}

  // Creamos un Subject para emitir eventos
  public functionExecution$: Subject<void> = new Subject<void>();
  public paymentSetupResult$ = new Subject<'link-success' | 'link-error'>();

  // Método para ejecutar la función
  executeFunction(): void {
    this.functionExecution$.next();
  }

  ngOnInit(): void {}

  realizarRecarga(recargaPlaceToPay: RecargaPlaceToPay) {
    return this.http.post('/place-to-pay/recarga', recargaPlaceToPay);
  }

  realizarSuscripcion(suscripcionPlaceToPay: SuscripcionPlaceToPay) {
    return this.http.post('/place-to-pay/suscripcion', suscripcionPlaceToPay);
  }

  realizarNotificacion(notificacionPlaceToPay: NotificacionPlaceToPay) {
    return this.http.post(`${globalConfig.apiUrlBackTolis}/place-to-pay/notificacion`, notificacionPlaceToPay, {
      headers: {
        'Skip-Interceptor': '',
      },
    });
  }

  desvincularTarjeta(idCuenta: string) {
    return this.http.delete(`/place-to-pay/desvinculacion-empresa/${idCuenta}`);
  }

  cambiarTipoPago(idCuenta: string, cuenta: Cuenta) {
    return this.http.patch(`/place-to-pay/cambiar-tipo-pago-cuenta/${idCuenta}`, cuenta);
  }

  configurarRecargaAutomatica(configuracion: { montoRecarga: number; saldoMinimo: number }) {
    return this.http.patch('/recarga-automatica/configuracion', configuracion);
  }

  cambiarPrimerInicioAFalse() {
    return this.http.patch(`/usuario-cuenta-empresarial/change-primer-inicio`, {});
  }

  getMedioPagoByCuentaId() {
    const cuentaId = this.guardService.usuarioData().cuenta?.id;
    this.#stateMedioPago.set({ medioPago: [], loading: true, cuentaId });
    return this.http
      .get('/medio-pago/by-cuenta-id')
      .pipe(
        map(({ data }: any) => {
          return data;
        }),
      )
      .subscribe({
        next: (medioPago: any) => {
          if (this.guardService.usuarioData().cuenta?.id === cuentaId) {
            this.#stateMedioPago.set({ medioPago, loading: false, cuentaId });
          }
        },
        error: () => {
          if (this.guardService.usuarioData().cuenta?.id === cuentaId) {
            this.#stateMedioPago.set({ medioPago: [], loading: false, cuentaId });
          }
        },
      });
  }

  refreshEnterpriseAccount() {
    const activeAccountId = this.guardService.usuarioData().cuenta?.id;
    return this.guardService.authenticated().pipe(
      map((response: any) => {
        const { cuenta, ...usuario } = response?.data?.usuario ?? {};
        if (this.guardService.usuarioData().cuenta?.id !== activeAccountId) return null;
        const activeAccount = cuenta?.find((item: any) => item.id === activeAccountId);
        if (!activeAccount) throw new Error('No se pudo actualizar la cuenta empresarial activa.');
        const token = response?.data?.access_token;
        if (token && token !== sessionStorage.getItem(globalConfig.tokenApi)) this.guardService.setToken(token);
        this.guardService.setUserData(activeAccount, usuario);
        return activeAccount;
      }),
    );
  }

  async getIpAddress() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      this.ipAddress = data.ip;
    } catch (error) {
      console.log({ ipify: error });
    }
  }
}
